import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    align-items: center;
    padding-top: 8px;
    margin: 0 auto;
`
